import { store } from '@longsien/react-store';

export const categoriesStore = store();
